/**
 * /_kit — the developer's view of the foundation: the type scale, the five
 * tones, the display formats, and the two layouts in both languages. The kit
 * atoms land here as they are built, and the e2e fit audit reads this page.
 *
 * ONE `<section>` PER ATOM, through `Section`, and every state an atom has is
 * mounted in it. That is not tidiness: `e2e/fit.spec.ts` drives this page in
 * 2 languages × 2 layouts × 2 viewports, so a state drawn here is measured
 * eight times for nothing, and a state left off is not measured at all.
 *
 * Open without signing in, and it shows no patient data: every value is a
 * sample.
 */
import { createFileRoute, notFound } from "@tanstack/react-router";
import { previewRoutesOn } from "@/api/config";
import { KitPage } from "./-kit/kit-page";

export const Route = createFileRoute("/_kit")({
  // NOT A ROUTE IN A BUILD THAT TALKS TO A SERVER. This page carries sample
  // values and explains the kit to whoever is building it; at a pharmacy it is a
  // page somebody eventually finds and reads as the product. A mock build keeps
  // it, which is what the fit audit measures.
  beforeLoad: () => {
    if (!previewRoutesOn()) throw notFound();
  },
  component: KitPage,
});
